<template>
    <div ref="chart"></div>
</template>
<script>
import Highcharts from "highcharts";

export default {
    name: "chart-rtp",
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            chart: null
        };
    },
    methods: {
        reload() {
            if (this.chart) this.chart.destroy();

            let series = [];
            this.data.currencies.forEach(c => {
                series.push({
                    name: `${c.currency} - RTP`,
                    data: c.rtp

                })
            });

            this.chart = Highcharts.chart(this.$refs.chart, {
                chart: {
                    type: "spline"
                },
                title: {
                    text: ""
                },
                xAxis: {
                    type: "datetime"
                },
                yAxis: {
                    title: {
                        text: '%'
                    },
                    plotLines: [{
                        value: 100,
                        color: '#888',
                        width: 1,
                        zIndex: 4
                    }]
                },
                legend: {
                    layout: "vertical",
                    align: "right",
                    verticalAlign: "middle"
                },
                tooltip: {
                    crosshairs: true,
                    shared: true
                },
                plotOptions: {
                    line: {
                        dataLabels: {
                            enabled: true
                        },
                        pointInterval: 24 * 60 * 60 * 1000 // one day
                    },
                    series: {
                        marker: {
                            symbol: "circle",
                            radius: 3
                        }
                    }
                },
                series: series
            });
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/client/stats/chart-rtp.vue